module.exports = __webpack_public_path__ + "3ba3d3f8b0ff42a8.svg";